// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__Epz-5","box":"CheckBox_box__1-cgN","mark":"CheckBox_mark__7I124","label":"CheckBox_label__Q0Qga","labelDisabled":"CheckBox_labelDisabled__oOhDE"};